import React from 'react';
import useProps from '../_util/useProps';
import { useEffect } from 'react';
import HighlightLayer from './HighlightLayer';
import { registerEventLayer } from '../events';

export default function(props) {
    const { map } = useProps();
    useEffect(() => {
        const highlightLayer = new HighlightLayer(props);
        // 注册事件
        registerEventLayer(highlightLayer, props);
    }, []);
    return <></>;
}
